const badges = [
  {
    icon: 'ri-nurse-line',
    title: 'ZMP mit 19 Jahren Erfahrung',
    description: 'Als zertifizierte Zahnmedizinische Prophylaxe-Assistentin bringe ich echtes Fachwissen in jede kosmetische Anwendung.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'PAP-Technologie (peroxidfrei)',
    description: 'Wir arbeiten ausschließlich mit moderner PAP-Technologie — schonend für den Zahnschmelz und ohne Peroxid.',
  },
  {
    icon: 'ri-file-check-line',
    title: 'EU-Kosmetikverordnung konform',
    description: 'Alle verwendeten Produkte entsprechen der europäischen Kosmetikverordnung und sind klinisch geprüft.',
  },
  {
    icon: 'ri-heart-line',
    title: 'Individuelle Betreuung',
    description: 'Keine Fließband-Anwendung. Alle die zu uns kommen, bekommen die Zeit und Aufmerksamkeit, die sie verdienen.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Vor Ort in Köln',
    description: 'Dein lokales Boutique-Studio für kosmetische Zahnaufhellung in Köln — immer gut erreichbar.',
  },
  {
    icon: 'ri-leaf-line',
    title: 'Hautverträgliche Produkte',
    description: 'Nur geprüfte, hautverträgliche Produkte — für alle mit empfindlichen Zähnen und Zahnfleisch.',
  },
  {
    icon: 'ri-women-line',
    title: 'Female-Founded Business',
    description: 'Flow & Glow ist ein inhabergeführtes Studio — gegründet und geleitet von Jenny, für alle die strahlen möchten.',
  },
  {
    icon: 'ri-group-line',
    title: 'Jede Person willkommen',
    description: 'Bei uns ist jede Person willkommen — unabhängig von Geschlecht, Identität, Herkunft oder Alter.',
  },
];

export default function TrustBadges() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="font-sans text-xs tracking-widest uppercase text-rose font-semibold">
            Warum Flow & Glow
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-charcoal mt-3 mb-4">
            Meine Versprechen an dich
          </h2>
        </div>

        {/* Badges grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {badges.map((badge, i) => (
            <div
              key={i}
              className="flex flex-col gap-4 p-7 rounded-2xl ring-2 ring-blush hover:ring-rose transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-rose/15 rounded-xl">
                <i className={`${badge.icon} text-rose text-xl`} />
              </div>
              <div>
                <h3 className="font-sans text-base font-semibold text-charcoal mb-2">{badge.title}</h3>
                <p className="font-sans text-sm text-charcoal/65 leading-relaxed">{badge.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
